import { render, staticRenderFns } from "./carrier-detail.vue?vue&type=template&id=0a7f870d"
import script from "./carrier-detail.vue?vue&type=script&lang=js"
export * from "./carrier-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports